import styled from "styled-components";
import themeGet from "@styled-system/theme-get";
import Avatar, { AvatarImage } from "../../global/avatar";
import ButtonLink from "../../global/buttonLink";

export const ProfileHeading = styled.h3`
  margin-bottom: 0;
`;

export const ProfileAvatar = styled(Avatar)`
  width: 100%;
  height: auto;
  text-align: center;
`;

export const ProfileAvatarImg = styled(AvatarImage)`
  width: 30%;
  height: auto;
  
  ${themeGet("mediaQueries.mediumUp")} {
    width: 50%;
  }

  ${themeGet("mediaQueries.xxLarge")} {
    width: 100%;
  }
`;

export const ProfileAvatarLink = styled(ButtonLink)`
  display: block;
  text-align: center;
  margin: 0 auto;
`;
